const NoResultsIcon = () => {
  return (
    <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="file">
      <path
        id="Vector"
        d="M37.8332 5.3335V16.0002C37.8332 17.4147 38.3951 18.7712 39.3953 19.7714C40.3955 20.7716 41.752 21.3335 43.1665 21.3335H53.8332M40.4998 5.3335H16.4998C15.0853 5.3335 13.7288 5.8954 12.7286 6.89559C11.7284 7.89579 11.1665 9.25234 11.1665 10.6668V53.3335C11.1665 54.748 11.7284 56.1045 12.7286 57.1047C13.7288 58.1049 15.0853 58.6668 16.4998 58.6668H48.4998C49.9143 58.6668 51.2709 58.1049 52.2711 57.1047C53.2713 56.1045 53.8332 54.748 53.8332 53.3335V18.6668L40.4998 5.3335Z"
        stroke="#9BA3AE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
  );
};

export default NoResultsIcon;
